/** Perfiles despacho — etiquetas UI y texto de referencia (equipo básico). */

export const AUXILIARY_DESPACHO_ROLES = [
  { value: "auxiliar", label: "Auxiliar" },
  { value: "supervisor", label: "Administrador de equipo" },
  { value: "consulta", label: "Consulta (solo lectura)" },
];

export const AUXILIARY_ROLE_HINTS = {
  auxiliar:
    "Opera CFDI, visores, carga y chat. Puede dar de alta empresas y capturar sus datos (RFC, contacto, FIEL); no puede eliminarlas ni gestionar licencia.",
  supervisor:
    "Acceso operativo completo del espacio: alta y datos de empresas, auxiliares y operación diaria. Sin licencia BNT ni diseño.",
  consulta: "Solo consulta información; no modifica datos ni usuarios.",
};

export const AUXILIARY_ROLES_GUIDE = [
  {
    key: "owner",
    title: "Propietario / titular",
    body: "Licencia, configuración del espacio, empresas, usuarios y todas las herramientas.",
  },
  {
    key: "supervisor",
    title: "Administrador de equipo",
    body: "Da de alta y edita empresas, gestiona auxiliares y opera el día a día. No emite licencias ni usa herramientas de diseño BNT.",
  },
  {
    key: "auxiliar",
    title: "Auxiliar",
    body: "Trabaja en módulos operativos (carga, visores, confronta, chat), da de alta empresas y captura sus datos. No elimina empresas ni gestiona el equipo.",
  },
  {
    key: "consulta",
    title: "Consulta",
    body: "Solo lectura en listados y reportes; no modifica datos.",
  },
];

export function despachoRoleLabel(value) {
  return AUXILIARY_DESPACHO_ROLES.find((r) => r.value === value)?.label || value || "—";
}

export function despachoRoleHint(value) {
  return AUXILIARY_ROLE_HINTS[value] || "";
}

/** Alinea `role` de workspace con el perfil despacho al crear/editar auxiliares. */
export function workspaceRoleFromDespachoRole(despachoRole) {
  const dr = String(despachoRole || "auxiliar").trim().toLowerCase();
  if (dr === "consulta") return "consulta";
  // supervisor y auxiliar operan como role=user; el perfil vive en despacho_profile.
  return "user";
}

/** Titular, buyer_admin, supervisor o administrador (Configuración) pueden administrar el equipo. */
export function canManageWorkspaceTeam(user) {
  if (!user) return false;
  if (user.is_admin_owner) return true;
  if (user.is_buyer_tenant && user.role === "buyer_admin") return true;
  const dr = user.despacho_profile?.despacho_role || user.despacho_role;
  if (dr === "supervisor") return true;
  if (dr === "consulta") return false;
  if (user.role === "admin" && !user.is_buyer_tenant) return true;
  return false;
}

/** Rol de visor en bandejas embebidas (BNT Asistente, mensajes): admin de equipo = titular operativo. */
export function resolveDespachoViewerRole(user) {
  return canManageWorkspaceTeam(user) ? "owner" : "auxiliar";
}
